var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdateManual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4369 16.8533H2.56305C2.25806 16.8533 2 17.1161 2 17.4267C2 17.7372 2.25806 18 2.56305 18H17.4369C17.7419 18 18 17.7372 18 17.4267C18 17.1161 17.7419 16.8533 17.4369 16.8533ZM2.02346 11.8365L2 14.536C2 14.6794 2.04692 14.8466 2.16422 14.9421C2.28153 15.0377 2.42229 15.1094 2.56305 15.1094L5.21408 15.0855C5.35484 15.0855 5.4956 15.0138 5.6129 14.9183L14.7155 5.64912C14.9267 5.43412 14.9267 5.05188 14.7155 4.83688L12.088 2.16125C11.8768 1.94625 11.5015 1.94625 11.2903 2.16125L9.46041 4.02464L2.18768 11.4304C2.07038 11.5498 2.02346 11.6932 2.02346 11.8365ZM13.5191 5.243L12.4868 6.29414L10.6569 4.43076L11.6892 3.37962L13.5191 5.243ZM3.14956 12.0754L9.85924 5.243L11.6892 7.10638L4.97947 13.9388H3.14956V12.0754Z",
    fill: "#344157"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateManual);
export default __webpack_public_path__ + "static/media/updateManual.8a1cc16b.svg";
export { ForwardRef as ReactComponent };